/** Shared defaults/derivations for the shared-document + upload-hub landing page colours. */

export const DEFAULT_BACKGROUND_COLOUR = '#FFFFFF';

/** How much darker the controls bar is than the background, as a ratio of black (0-1). */
export const BAR_BACKGROUND_DARKEN = 0.2;

/** Mix a #RRGGBB hex towards black. `amount` is the ratio of black (0-1). Non-hex input is returned untouched. */
export const darkenHexColor = (hex: string, amount = 0.12): string => {
  const match = /^#?([0-9a-f]{6})$/i.exec(hex?.trim() ?? '');
  if (!match) return hex;

  const num = parseInt(match[1], 16);
  const factor = 1 - Math.min(1, Math.max(0, amount));
  const channel = (shift: number) => Math.round(((num >> shift) & 0xff) * factor);

  return `#${((channel(16) << 16) | (channel(8) << 8) | channel(0)).toString(16).padStart(6, '0')}`;
};

/** Bar colour = the saved override, else a darker shade of the background (or the default background). */
export const resolveBarBackgroundColor = (
  backgroundColor?: string | null,
  barBackgroundColor?: string | null
): string => barBackgroundColor || darkenHexColor(backgroundColor || DEFAULT_BACKGROUND_COLOUR, BAR_BACKGROUND_DARKEN);
